import { shallowMount } from "@vue/test-utils";
import Paso4 from "@/views/Paso4";

describe("Paso4 component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Paso4);
  });

  it("Renders del component Paso4", () => {
    expect(wrapper).toBeDefined();
  });
});
